import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  lots: [],
  maps: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalLots: 0,
    totalPages: 0
  },
  lotsCatalog: {},
  categoriesCatalog: [],
  excedente: '',
  dateComplete: '',
  filterParams: '',
  visible: false,
  isModalVisible: false,
  isModalLotsManyVisible: false,
  isModalImagesVisible: false
}

const mutations = {
  SET_LOTS (state, payload) {
    state.lots = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalLots: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_CATEGORIES_CATALOG (state, payload) {
    state.categoriesCatalog = payload
  },
  SET_EXCEDENTE (state, payload) {
    state.excedente = payload
  },
  SET_DATE_COMPLETE (state, payload) {
    state.dateComplete = payload
  },
  SET_MAPS (state, payload) {
    state.maps = payload
  },
  ADD_LOT (state, payload) {
    state.lots.unshift(payload)
  },
  UPDATE_LOT (state, payload) {
    const idx = state.lots.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.lots, idx, payload)
    }
  },
  DELETE_LOT (state, payload) {
    const idx = state.lots.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.lots, idx)
    }
  },
  DELETE_LOTS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.lots.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.lots, idx)
      }
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_VISIBLE (state, payload) {
    state.visible = payload
  },
  SET_MODAL_LOTS_MANY_VISIBLE (state, payload) {
    state.isModalLotsManyVisible = payload
  },
  SET_MODAL_IMAGES_VISIBLE (state, payload) {
    state.isModalImagesVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.lotsCatalog[object] = payload.data
  },
  SET_LOTS_CATALOG (state, payload) {
    state.lotsCatalog = { ...state.lotsCatalog, ...payload }
  }
}

const actions = {
  async loadLots ({ commit }, payload) {
    if (!payload.map_id) { payload.map_id = 1 }
    app.$Progress.start()
    try {
      const response = await axios.get(`lots?page=${payload.page}&map_id=${payload.map_id}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadMaps ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`maps/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MAPS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCategoriesCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`categories/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATEGORIES_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadExcedent ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`lots/excedente/${payload.map_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EXCEDENTE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadDateComplete ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`lots/date-complete/${payload.map_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_DATE_COMPLETE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addLot ({ commit }, payload) {
    const lot = {
      // columnas
      // sku: payload.sku,
    }

    app.$Progress.start()

    try {
      const response = await axios.post('lots', lot)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_LOT', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editLot ({ commit }, payload) {
    commit('SET_VISIBLE', true)
    const lot = {
      id: payload.id,
      layer_id: payload.layer_id,
      title: payload.title,
      park: payload.park,
      square_meter: payload.square_meter,
      discount_voucher: payload.discount_voucher,
      construction_mts: payload.construction_mts,
      surface_mts: payload.surface_mts,
      completion_date: payload.completion_date,
      category: payload.category,
      category_id: payload.category_id,
      fill: payload.fill,
      x: payload.x,
      y: payload.y,
      zoom: parseInt(payload.zoom),
      status: parseInt(payload.status),
      map_id: parseInt(payload.map_id)
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`lots/${payload.id}`, lot)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_LOT', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('SET_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editLotMany ({ commit }, payload) {
    commit('SET_VISIBLE', true)
    const lot = {
      park: payload.park,
      square_meter: payload.square_meter,
      discount_voucher: payload.discount_voucher,
      construction_mts: payload.construction_mts,
      completion_date: payload.completion_date,
      category_id: payload.category_id,
      ids: payload.ids
    }
    if (payload.status !== null) lot.status = payload.status
    app.$Progress.start()

    try {
      const response = await axios.post(`lots/edit-many/`, lot)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_LOT', response.data)
        commit('SET_MODAL_LOTS_MANY_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('SET_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },

  async editHouse ({ commit }, payload) {
    const lot = {
      id: payload.id,
      layer_id: payload.layer_id,
      title: payload.title,
      park: payload.park,
      square_meter: payload.square_meter,
      discount_voucher: payload.discount_voucher,
      construction_mts: payload.construction_mts,
      surface_mts: payload.surface_mts,
      completion_date: payload.completion_date,
      category: payload.category,
      category_id: payload.category_id,
      fill: payload.fill,
      x: payload.x,
      y: payload.y,
      zoom: parseInt(payload.zoom),
      status: parseInt(payload.status),
      map_id: parseInt(payload.map_id)
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`lots/${payload.id}`, lot)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_LOT', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteLotImage ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`lot-image/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteLot ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`lots/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_LOT', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteLots ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`lots/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_LOTS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionLot ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`lots/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_LOT', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.lots', text: `lots.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/lots/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadLotsCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`lots/catalog`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.lots', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOTS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalLostManyVisible ({ commit }, payload) {
    commit('SET_MODAL_LOTS_MANY_VISIBLE', payload)
  },
  setModalImagesVisible ({ commit }, payload) {
    commit('SET_MODAL_IMAGES_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  lots: state => state.lots,
  lot: state => state.lot,
  maps: state => state.maps,
  lotsCatalog: state => state.lotsCatalog,
  categoriesCatalog: state => state.categoriesCatalog,
  excedente: state => state.excedente,
  dateComplete: state => state.dateComplete,
  pagination: state => state.pagination,
  visible: state => state.visible,
  isModalVisible: state => state.isModalVisible,
  isModalLotsManyVisible: state => state.isModalLotsManyVisible,
  isModalImagesVisible: state => state.isModalImagesVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
